<script>
  import { Styles, Button } from 'sveltestrap';
  import { Textfield } from 'svelte-mui';
  import { api_url } from "../ConfigService.js";
  import { Router, Route, Link, navigate } from "svelte-routing";
  import CardStats from "../fotomaturak/CardStats.svelte";
  import Loading from "../components/Loading.svelte";

  import PhotoOrder from "../pages/PhotoOrder.svelte";
  import Imgupload from '../components/Imgupload.svelte';

  export let share=false;
  export let orderno;
  export let ordernoInput;
  export let error;
  
  export let isOrder=false;
  function setOrder(value) { isOrder=value; return ""; }
  
  export let data = (async () => {
	 const resp = await fetch($api_url);
	 return await resp.json()
  })()

  export let url="";


  function openOrder() {
  	orderno=ordernoInput.toUpperCase();
	if(orderno) { navigate('/photos/'+orderno); }
  }
  
  const handleOpenOrder = () => {
	openOrder();
  }

  function shareDialog() {
    share=true;
  }

</script>

  <div class="flex flex-wrap items-stretch justify-center">       
         <div class="w-full lg:w-4/12 xl:w-4/12 px-4 px-mobile pb-4">
           <CardStats
             statSubtitle="Hlavní výhody"
             statIconName="fa fa fa-award"
             statIconColor="bg-red-500"
           >
            	<ul class="space-y-3 text-gray-700 text-xl">
		  <li class="flex items-start ">
		    <span class="text-blue-500 text-2xl pt-3"><i class="fa fa-object-ungroup"></i></span>
		    <span class="ml-3 pt-3">Jednoduchý výběr formátů a počtů fotografií - fotografie si zvládne objednat během pár minut každý</span>
		  </li>
		  <li class="flex items-start divide-y py-2">
		    <span class="text-green-500 text-2xl pt-3"><i class="fa fa-share-alt"></i></span>
		    <span class="ml-3 pt-3">Sdílejte své snímky s přáteli, kteří si následně mohou objednat tištěné fotografie</span>
		  </li>
		  <li class="flex items-start divide-y">
		    <span class="text-yellow-500 text-2xl pt-3"><i class="fa fa-image"></i></span>
		    <span class="ml-3 pt-3">Nejvyšší kvalita tisku díky chemickému zpracování na fotolabu Noritsu a vysoce kvalitnímu fotopapíru Fuji</span>
		  </li>
		  <li class="flex items-start divide-y">
		    <span class="text-red-500 text-2xl pt-3"><i class="fas fa-mobile-alt"></i></span>
		    <span class="ml-3 pt-3">Fotografie můžete nahrát jednoduše klidně i z vašeho telefonu</span>
		  </li>
		</ul>
		{#if data.text && data.text.length>0}
			{#if data.text[0].data.text}
				<!--<p>{@html data.text[0].data.text}</p>-->
			{/if}
		{/if}
           </CardStats>
         </div>
         
         <div class="w-full lg:w-4/12 xl:w-4/12 px-4 px-mobile pb-4">
           <CardStats
             statSubtitle="Ceník"
             statIconName="fa fa-solid fa-dollar-sign"
             statIconColor="bg-red-500"
           >
           <b>Fotografie vám vyrobíme za následující ceny:</b><br /><br />
            <table class="w-full border-collapse border border-gray-300 shadow-lg">
		  <thead>
		    <tr class="bg-gray-100 text-left">
		      <th class="px-4 py-2 border border-gray-300">Formát</th>
		      <th class="px-4 py-2 border border-gray-300">Cena</th>
		    </tr>
		  </thead>
		  <tbody class="divide-y divide-gray-300">
		    <tr class="hover:bg-gray-50">
		      <td class="px-4 py-2">10x15 cm</td>
		      <td class="px-4 py-2">7,- Kč</td>
		    </tr>
		    <tr class="hover:bg-gray-50">
		      <td class="px-4 py-2">13x18 cm</td>
		      <td class="px-4 py-2">13,- Kč</td>
		    </tr>
		    <tr class="hover:bg-gray-50">
		      <td class="px-4 py-2">15x20 cm</td>
		      <td class="px-4 py-2">17,- Kč</td>
		    </tr>
		    <tr class="hover:bg-gray-50">
		      <td class="px-4 py-2">20x30 cm</td>
		      <td class="px-4 py-2">55,- Kč</td>
		    </tr>
		  </tbody>
		</table>
		<br />
		<div class="right">Zaslání přes Zásilkovnu: 79,-Kč</div>
           </CardStats>
         </div>
         
         <div class="w-full lg:w-4/12 xl:w-4/12 px-4 px-mobile pb-4">
           <CardStats
             statSubtitle="Jak to funguje?"
             statIconName="fa fa-info"
             statIconColor="bg-red-500"
           >
            	<ul class="space-y-3 text-gray-700 text-xl">
		  <li class="flex items-start">
		    <span class="text-blue-500 text-2xl pt-3"><i class="fa fa-upload"></i></span>
		    <span class="ml-3 pt-3">Nahrajete vaše fotografie</span>
		  </li>
		  <li class="flex items-start divide-y">
		    <span class="text-blue-500 text-2xl pt-3"><i class="fa fa-list"></i></span>
		    <span class="ml-3 pt-3">Vyberete si formát a počet</span>
		  </li>
		  <li class="flex items-start divide-y">
		    <span class="text-green-500 text-2xl pt-3"><i class="fa fa-map-marker-alt"></i></span>
		    <span class="ml-3 pt-3">Vyberete si Z-BOX nebo místo Zásilkovny k vyzvednutí fotografií</span>
		  </li>
		  <li class="flex items-start divide-y">
		    <span class="text-yellow-500 text-2xl pt-3"><i class="fa fa-credit-card"></i></span>
		    <span class="ml-3 pt-3">Zaplatíte přes zabezpečenou platební bránu</span>
		  </li>
		  <li class="flex items-start divide-y">
		    <span class="text-red-500 text-2xl pt-3"><i class="fa fa-box"></i></span>
		    <span class="ml-3 pt-3">Do 4 pracovních dnů si fotografie vyzvednete na vybraném výdejním místě (kdekoliv v ČR)</span>
		  </li>
		</ul>
		<br />Jednodušší to už být nemůže :)
		{#if data.text && data.text.length>0}
			{#if data.text[0].data.text}
				<!--<p>{@html data.text[0].data.text}</p>-->
			{/if}
		{/if}
           </CardStats>
         </div>
         
         <div class="w-full lg:w-6/12 xl:w-6/12 px-4 px-mobile pb-4">
           <CardStats
             statSubtitle="Nahrát fotografie"
             statIconName="fa fa-solid fa-image"
             statIconColor="bg-red-500"
           >
            <b>Vyberte vaše fotografie ke zpracování:</b><br /><br />
            	<Imgupload />
           </CardStats>
         </div>
         
         <div class="w-full lg:w-auto xl:w-auto px-4 px-mobile pb-4">
           <CardStats
             statSubtitle="Pokračovat v objednávce"
             statIconName="fa fa-solid fa-lock-open"
             statIconColor="bg-red-500"
           >
            <b>Zobrazit již nahranou objednávku:</b><br /><br />
            	<form on:submit|preventDefault={handleOpenOrder}>
			<Textfield type="text" label="Zadejte číslo zakázky" name="code" bind:value={ordernoInput} bind:error required class="ordenoInput" on:blur={e => ordernoInput = e.target.value.toUpperCase()} />
			<Button color="{ordernoInput ? "primary" : "secondary"}" outlined on:click={openOrder}>Otevřít zakázku</Button>
		</form>
           </CardStats>
         </div>
  </div>
                	

<style>
h2 { font-size:20px; }
h3 { font-size:16px; font-weight:bold; margin-bottom:10px; }
.list-info { list-style-type:circle; }
.masterBox { min-width:80%; max-width:1715px; }
.right { float:right; }

@media (max-width: 768px) {
	.px-mobile { padding-left:0px!important; padding-right:0px!important; }
}
</style>
